var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_804_11313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.413 8.45783C16.4995 8.23906 16.5222 7.99833 16.478 7.76609C16.4339 7.53386 16.3249 7.32055 16.165 7.15317L11.5933 2.36541C11.4878 2.25109 11.3617 2.15991 11.2223 2.09718C11.0828 2.03445 10.9329 2.00143 10.7811 2.00005C10.6294 1.99866 10.4789 2.02895 10.3384 2.08913C10.1979 2.14931 10.0703 2.23819 9.963 2.35057C9.85569 2.46296 9.77083 2.5966 9.71336 2.7437C9.65589 2.8908 9.62697 3.04841 9.62829 3.20734C9.62961 3.36627 9.66114 3.52333 9.72104 3.66936C9.78094 3.81539 9.86801 3.94747 9.97717 4.05788L12.5991 6.80366H1.64293C1.33981 6.80366 1.0491 6.92977 0.834756 7.15423C0.620416 7.3787 0.5 7.68315 0.5 8.0006C0.5 8.31805 0.620416 8.62249 0.834756 8.84696C1.0491 9.07143 1.33981 9.19754 1.64293 9.19754H12.5991L9.97831 11.9421C9.86915 12.0525 9.78208 12.1846 9.72218 12.3306C9.66228 12.4767 9.63075 12.6337 9.62943 12.7927C9.62811 12.9516 9.65703 13.1092 9.7145 13.2563C9.77197 13.4034 9.85683 13.537 9.96415 13.6494C10.0715 13.7618 10.1991 13.8507 10.3395 13.9109C10.48 13.9711 10.6305 14.0013 10.7823 14C10.934 13.9986 11.084 13.9656 11.2234 13.9028C11.3629 13.8401 11.489 13.7489 11.5944 13.6346L16.1661 8.84683C16.272 8.7354 16.3559 8.60322 16.413 8.45783V8.45783Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_804_11313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionArrow);
export default __webpack_public_path__ + "static/media/ActionArrow.8f2b6c6a45449c46ec3d4213cba15dcb.svg";
export { ForwardRef as ReactComponent };